import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseAPI = createApi({
  reducerPath: "baseAPI",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  tagTypes: ["catalogues","metadata","spws","source","pointingsources","releasenote","spectralspws"],
  endpoints: () => ({})
});

